import Flow from '../../../services/Flow'
import { updateField } from 'vuex-map-fields'

const initialStateValue = {
  app: {},
  flow: {},
  typeConfig: { ...Flow.defaultFlowTypeConfig },
  codeInEditor: {},
  blocklyXml: '',
  editorMode: '',
  isFlowEditingDisabled: false,
  idCurrentFlowVersionOutdated: false,
  isCurrentUserAllowedToEditFlow: true,
  isBlocklyEnabled: true,
  isMainainerEdited: false,
  allFlows: [],
  allFields: [],
  allApps: [],
  groups: [],
  publication: {},
  isManagedApp: false,
  childComponentsValidation: {
    flowTriggers: {}
  }
}

const blankTriggers = { context: [], external: [], lifecycle: [], services: [] }

export default {
  updateFlowState(state, flow) {
    // I thnk this is a big bug
    state.flow = { ...flow } //{ ...state.flow, ...flow }
  },
  setEditorMode(state, mode) {
    state.editorMode = mode
  },
  clearStoreState(state) {
    state = { ...initialStateValue }
  },
  deleteFlowTrigger(state, { triggerType, idx }: { triggerType: string, idx: number }) {
    state.flow.typeConfig.triggers[triggerType] = _.filter(
      state.flow.typeConfig.triggers[triggerType],
      (t, i) => i !== idx
    )
  },
  addFlowTrigger(state, { triggerType, trigger }: { triggerType: string, trigger: any }) {
    if (!state.flow.typeConfig.triggers || !state.flow.typeConfig.triggers[triggerType]) {
      state.flow.typeConfig.triggers = {
        ...blankTriggers,
        ...state.flow.typeConfig.triggers
      }
    }
    state.flow.typeConfig = {
      ...state.flow.typeConfig,
      triggers: {
        ...state.flow.typeConfig.triggers,
        [triggerType]: [...state.flow.typeConfig.triggers[triggerType], _.cloneDeep(trigger)]
      }
    }
  },
  updateFlowTrigger(
    state,
    {
      newTrigger,
      triggerType,
      triggerIdx
    }: { newTrigger: any, triggerType: string, triggerIdx: number }
  ) {
    let copyOfStoreTriggers = _.cloneDeep(state.flow.typeConfig.triggers[triggerType])
    copyOfStoreTriggers.splice(triggerIdx, 1, _.cloneDeep(newTrigger))
    state.flow.typeConfig.triggers[triggerType] = [...copyOfStoreTriggers]
  },
  setIsCurrentUserAllowedToEditFlow(state, isAllowed: boolean) {
    state.isCurrentUserAllowedToEditFlow = isAllowed
  },
  setIsFlowEditingDisabled(state, isDisabled: boolean) {
    state.isFlowEditingDisabled = isDisabled
  },
  updateIsTriggerValid(
    state,
    {
      triggerType,
      triggerIdx,
      isValid
    }: { triggerType: string, triggerIdx: number, isValid: boolean }
  ) {
    let flowTriggers = state.childComponentsValidation.flowTriggers || {}
    if (!flowTriggers[triggerType]) flowTriggers[triggerType] = []
    flowTriggers[triggerType].splice(triggerIdx, 1, { idx: triggerIdx, isValid: isValid })
    state.childComponentsValidation = {
      ...state.childComponentsValidation,
      flowTriggers: flowTriggers
    }
  },
  updateField
}
